enum Variant {
  PRIMARY = "primary",
  ERROR = "error",
  SUCCESS = "success",
  LINK = "link"
}

export default Variant;
